<script lang="ts">
import { defineComponent, inject, PropType, ref } from "vue";
import TarifoptionenSelect from "@/components/tarifoptionen/TarifoptionenSelect.vue";
import { TarifoptionInformation } from "@/components/tarifoptionen/model/TarifoptionInformation";
import IconSprite from "@/components/IconSprite.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "Tarifoption",
  components: { TarifoptionenSelect, IconSprite },
  props: {
    tarifoptionInformation: Object as PropType<TarifoptionInformation>,
    istLetzteTarifoption: Boolean,
    tarifoptionentitel: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const piniaStore = useFormStore();
    const istSichtbar: any = inject("istSichtbar");
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");

    const titelText = ref(
      piniaStore.state.isMakler && props.tarifoptionInformation?.titelMakler !== undefined
        ? props.tarifoptionInformation?.titelMakler
        : props.tarifoptionInformation?.titel,
    );
    const selectName = ref(props.tarifoptionInformation?.selectname);
    const selectOptionen = ref(props.tarifoptionInformation?.selectoptionen);
    const produktLinien = ref(props.tarifoptionInformation?.produktLinien);

    function getCssForCol(produktlinie: string) {
      return "add-on__option " + (piniaStore.state.tarifinformationen.produktLinie === produktlinie ? "active" : "");
    }

    const zeigeInfoItem = () => {
      const verberge = piniaStore.state.isMakler
        ? props.tarifoptionInformation?.zeigeInfoItemMakler == false
        : props.tarifoptionInformation?.zeigeInfoItem == false;

      return props.tarifoptionInformation?.infoItem && !verberge;
    };

    function sollSichtbarSein() {
      if (props.tarifoptionInformation === undefined) {
        return false;
      }

      return !piniaStore.state.tarifOptionenZuVerbergen.includes(props.tarifoptionInformation.typ);
    }

    return {
      props,
      piniaStore,
      titelText,
      selectName,
      selectOptionen,
      produktLinien,
      getCssForCol,
      istSichtbar,
      wechsleSichtbarkeit,
      zeigeInfoItem,
      sollSichtbarSein,
    };
  },
});
</script>

<template>
  <div v-if="sollSichtbarSein()" class="o-grid mobil-schmaler">
    <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 row-label">
      <h1 v-if="props.tarifoptionentitel !== undefined" class="u-form-heading unset-text-align">
        {{ props.tarifoptionentitel }}
      </h1>
      <span v-else class="row_label__fix"
        >{{ titelText }} &nbsp;
        <span
          v-if="zeigeInfoItem(props.tarifoptionInformation)"
          class="gev19__contexthelp-open"
          title="Hilfe anzeigen"
          @click="wechsleSichtbarkeit(props.tarifoptionInformation?.infoItem?.name)"
        >
        </span>
      </span>
    </div>
    <div
      v-if="zeigeInfoItem(props.tarifoptionInformation)"
      v-show="istSichtbar(props.tarifoptionInformation?.infoItem?.name)"
      class="c-modal"
      data-modal=""
    >
      <section class="c-modal__content">
        <header class="c-modal__header">
          <h1 class="c-modal__title">
            {{ props.tarifoptionInformation?.infoItem?.titel }}
          </h1>
          <button
            type="button"
            class="c-button c-button--icon-only-white"
            data-modal-hide=""
            @click="wechsleSichtbarkeit(props.tarifoptionInformation?.infoItem?.name)"
          >
            <icon-sprite icon-name="icon-cross" />
            <span class="c-button__visually-hidden">close</span>
          </button>
        </header>
        <section class="c-modal__content-section">
          {{ props.tarifoptionInformation?.infoItem?.text }}
        </section>
      </section>
    </div>
    <tarifoptionen-select
      v-if="props.tarifoptionInformation.typ === 'deckungssumme'"
      typ="deckungssumme"
      :produktlinien="props.tarifoptionInformation?.produktLinien"
      :selectName="selectName"
      :selectOptionen="selectOptionen"
      v-model.number="piniaStore.state.tarifinformationen.versicherungssumme"
    />
    <tarifoptionen-select
      v-if="props.tarifoptionInformation?.typ === 'deckungssumme-hg'"
      typ="deckungssumme-hg"
      :produktlinien="props.tarifoptionInformation.produktLinien"
      :selectName="selectName"
      :selectOptionen="selectOptionen"
      v-model.number="piniaStore.state.tarifinformationen.deckungssumme"
    />
    <tarifoptionen-select
      v-if="props.tarifoptionInformation?.typ === 'selbstbeteiligung'"
      typ="selbstbeteiligung"
      :produktlinien="props.tarifoptionInformation.produktLinien"
      :selectName="selectName"
      :selectOptionen="selectOptionen"
      v-model.number="piniaStore.state.tarifinformationen.selbstbeteiligung"
    />
    <tarifoptionen-select
      v-if="props.tarifoptionInformation?.typ === 'anzahlvorschaeden'"
      typ="anzahlvorschaeden"
      :produktlinien="props.tarifoptionInformation.produktLinien"
      :selectName="selectName"
      :selectOptionen="selectOptionen"
      v-model.number="piniaStore.state.tarifinformationen.vorschaedenAnzahl"
    />
    <tarifoptionen-select
      v-if="props.tarifoptionInformation?.typ === 'schadenfreiheitsrabatt'"
      typ="schadenfreiheitsrabatt"
      :produktlinien="props.tarifoptionInformation.produktLinien"
      :selectName="selectName"
      :selectOptionen="selectOptionen"
      v-model.number="piniaStore.state.tarifinformationen.sfr"
    />
  </div>
  <div v-if="!istLetzteTarifoption && sollSichtbarSein()" class="o-grid to-gimmick">
    <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480">&nbsp;</div>
    <div
      class="div2 o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200"
    >
      <div class="tarif-options-module tarif-options-module--add-on">
        <div class="o-grid o-grid--no-y-gutter add-on js-option">
          <div v-for="produktLinie in produktLinien" :key="produktLinie" :class="getCssForCol(produktLinie)">
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
